import React from "react";
import { Button, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Admen = () => {
  const { t } = useTranslation();
  return (
    <Row
      style={{
        background: "white",
        textAlign: "center",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <h1>{t("dashboard.sessionsAdmin.title")}</h1>
      <div className="d-flex gap-2 align-items-center">
        <Button variant="danger" id="verify-btn">
          {t("dashboard.sessionsAdmin.exportExcel")}
        </Button>
        <Button variant="danger" id="verify-btn">
          {t("dashboard.sessionsAdmin.importExcel")}
        </Button>
        <Button variant="danger" id="verify-btn">
          {t("dashboard.sessionsAdmin.update")}
        </Button>
        <Button variant="danger" id="verify-btn">
          {t("dashboard.sessionsAdmin.delete")}
        </Button>
        <Button variant="danger" id="verify-btn">
          {t("dashboard.sessionsAdmin.showHide")}
        </Button>
        <Button variant="danger" id="verify-btn">
          {t("dashboard.sessionsAdmin.closeSessions")}
        </Button>
      </div>
      <Table
        className="table-drag"
        style={{ background: "white", textAlign: "center" }}
      >
        <thead style={{ background: "white" }}>
          <tr>
            <th style={{ width: "100px" }}>{t("dashboard.sessionsAdmin.table.name")}</th>
            <th style={{ width: "100px" }}>
              {t("dashboard.sessionsAdmin.table.startTime")}
            </th>
            <th style={{ width: "100px" }}>
              {t("dashboard.sessionsAdmin.table.endTime")}
            </th>
            <th style={{ width: "100px" }}>{t("dashboard.sessionsAdmin.table.ip")}</th>
            <th style={{ width: "100px" }}>
              {t("dashboard.sessionsAdmin.table.closeSessions")}
            </th>
          </tr>
        </thead>
      </Table>
      <div
        style={{
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <h3>{t("dashboard.sessionsAdmin.noData")}</h3>
      </div>
    </Row>
  );
};

export default Admen;
